module.exports = __webpack_public_path__ + "img/mailbox.4147bc34.svg";